import { render, staticRenderFns } from "./HeaderBtn.vue?vue&type=template&id=5bc15b0a&"
import script from "./HeaderBtn.vue?vue&type=script&lang=js&"
export * from "./HeaderBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports